import { render, staticRenderFns } from "./Produtos.vue?vue&type=template&id=4dfaa9c2"
import script from "./Produtos.vue?vue&type=script&lang=ts"
export * from "./Produtos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports